export default {
    listagem: {
        titulo_pagina: 'Resultados Descartáveis',
        table: {
            empty: 'Nenhum Vns encontrado',
            nome: 'Vns',
            empresa: 'Empresa',
            resultado_descartavel: 'Resultado Descartável',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            editar: 'Editar Resultados Descartáveis'
        },
        fields: {
            vns: {
                label: 'Vns',
                description: 'Nome do Vns'
            },
            report_trash: {
                label: 'Resultados Descartáveis',
                description: 'Resultados que serão descartados por vns'
            },
            botao_salvar : 'Salvar Resultados Descartáveis'
        },
        update: {
            success: 'Resultados descartáveis atualizados com Sucesso!',
            error: 'Erro ao atualizar os resultados descartáveis!'
        }
    }
}
